@defer {
  <div id="settinsPanel" class="as-panel as-panel--large as-columns">
    <asg-sidebar [activeSideTab]="messageKey"></asg-sidebar>
    <asg-settings-view class="viewContainer"></asg-settings-view>
  </div>
}


